import React from 'react';

const Context = React.createContext()

export default Context;
export const Provider = Context.Provider;
export const Consumer = Context.Consumer;